import Platter from './platter';

export default Platter;
